<template>
<div v-if="selected_device">
    <button type="button" class="btn btn-info" @click="writeToSelectedPrinter();"><i class="fas fa-fw fa-print"></i> Label</button>
    <!--<div class="ml-2">
        <div class=""><br />BP: {{BrowserPrint.Device}} </div>
        <div class=""><br />Selected: {{selected_device}} </div>
        <div class=""><br />Devices: {{devices}} </div>
    </div>-->
</div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'LabelPrinter',
    components: {

    },
    props: {
        job: Object,
    },
    data() {
        return {
            available_printers: null,
            selected_category: null,
            default_printer: null,
            selected_device: null,
            devices: [],
            default_mode: true,
            BrowserPrint: null
        }
    },
    computed: {

    },
    mounted() {
        console.log('mounted')
        const _ = this;
        // As an instance method inside a component
        this.$loadScript("BrowserPrint-3.0.216.min.js")
            .then(() => {
                // Script is loaded, do something
                //_.BrowserPrint = window.BrowserPrint
                console.log("browser", window.BrowserPrint)
                _.BrowserPrint = window.BrowserPrint;
                _.printSetup();
            })
            .catch(() => {
                // Failed to fetch script
            });
    },
    methods: {
        writeToSelectedPrinter() {
            const _ = this,
                jobid = _.$options.filters.jobid(_.job.jobid),
                submitted = _.$options.filters.fullDateStatic(_.job.submitted);
            var dataToWrite = `^XA~TA000~JSN^LT0^MNW^MTT^PON^PMN^LH0,0^JMA^PR2,2~SD30^JUS^LRN^CI0^XZ
^XA
^MMT
^PW799
^LL1199
^LS0
^FO32,32^GFA,05120,05120,00016,:Z64:
eJztl8FuHEUQhqtnNpmJHRhHwC3SjAgSK+ew1xyQdiWCyIEDB3zLQ/AE2ZY4sLIPPvACK8TB4pJH8FoCKeSUR1hFHFY5LSChxrSnqJqd6a5u21nWlgISlLSSP//b3VXV1dW9AP/bOUsQsRacRVxEPIwYN2MVcYp/nh6/knxii7nkr0y6EO7VyigjOTUg2aZLsMJ9S3od6U+EbkLOTLaEcaAbybGe8fixfv14FLoN50sbPfDPKsGpTes0YIWZZFKD/NYqYgjZEov8wBzGKPIHvMPLgAucB5zhLOCk1nBFSxGDesj+Yb6x19gXV43nAntAn5ngjyjqueAnEdPeFjL/VDuF2B9FyS/F/qWsB+eJa0hwvfp0ltVNTVzOltfw3Kwt69esfHyz+uX+xfHx31mQjzA/iljmT1FxD+V5oMMQnAesnwY8pnqR+8P9cC64JJ4J5v6pBXPJCYTw+MJtOp5yuUIPgumzpZLeQnEKgRUY8yLgLDj8jXs64nnEQXdQkfscfzAgw2gFii9YoQzzA9vRChCvMIhWSDFqUMfRBGWQUdaDGFW0I0W0Y+OQ6YI00gEKcD4WTAnQQ8+K4y890+wLEDfakCcvXQBJs/1ez5ps+PGr/Qh0CHWOfSiY/xzOPHOoheNVb0i9vioP7dgpK3sb1tgDORqa/qbkHPX5/pZt2t8Cjs533N/sBf1sbX8T+hvub+f42v1tdkF/04KXQX9LuL+dev0trv7fR45zOjz46shxxf3tp0eOp3Q6cep1zf2t+s7zNp//b91y0BvjL3DHc3KMLxPdOdAD+NHe7UHnQA6wuzXt96uWdwC+VCcns44rSPbN/hZ4vj22L3b4ey330egJz9PYCD5Fo5559+AQTfrSsyrRUn32Ok6GaKjHJm32uDuY8o+OaV46r4XRHb97C89s5vKdvH+Ac5NSA1z9Jxl9g/R+rXmihif3amBu9Ru9zCqr6pEbf8ivW6ffHH3Nr1/sdNBPWceq1RUM+H4gvV0PBo0+bblHbwvVvDd16/5gKcfnrIvxeTu++34FH9J45davGt37/xha/9v49um9CjJ+eIfe75SfLn7q/toUVrv83qL3f3nm9yNHY9DlnyLg99qvXuefL+j3b9R075/9/nHzR7n/3O133PcruE/1WTkd4A7175GrnzzPqfy1qy86ayX2wNfn1vfTo8p3wF5WP1Y/eE626+dHR57VNuXug277yQ4o930fHnzc5Lbn+D7tXV+49x6d90fgA9giPffuwU18Bp+Bt4RuH73w42H4G3zOHjo2093prufC3v1EXqcpTva1R7WHZ3t7UsbgOm1+3+HlerpGv+74f7up6LcF/fp77X2Vci+PWcYf3R/n9Ib1mvFej+6f/MBOJodeH2KY/7/H9Rq2EZuIFxF7d6t7pqoqH84qvk04fDoCPIQNrPn1LeJpGa+uZ9ccDw/ZNonhv2N/AaBsekE=:059C
^FO19,11^GB764,1172,4^FS
^FO671,754^GB76,294,3^FS
^FT172,1063^A0B,169,168^FH\^FD${jobid}^FS
^FT724,1159^A0B,45,45^FH\^FDDate^FS
^FT290,1159^A0B,49,48^FH\^FDPALLET#^FS
^FO470,16^GB0,1167,4^FS
^FT548,1159^A0B,51,57^FH\^FDTIME TRACKING^FS
^FT620,520^A0B,45,48^FH\^FDTotal no. of Hours:^FS
^FT620,1158^A0B,45,48^FH\^FDTM Working Hours:^FS
^FO671,58^GB76,430,3^FS
^FT724,688^A0B,45,45^FH\^FDSignature^FS
^FO583,679^GB76,80,3^FS
^FO583,59^GB76,80,3^FS
^FT155,330^A0B,17,18^FH\^FDwww.itrecycla.co.nz | 0800 3342 8773^FS
^FO240,743^GB65,224,3^FS
^FT106,1159^A0B,42,40^FH\^FDJob#^FS
^FT218,1159^A0B,25,24^FH\^FDCreated: ${submitted}^FS
^FO80,365
^BQN,2,10
^FDQA,https://app.itrecycla.co.nz/#/job/${jobid}^FS`;

            if (_.job.datadestruction !== 'No') {
                dataToWrite += `^FO328,743^GB112,416,12^FS
^FT405,1143^A0B,56,55^FB388,1,0,C^FH\^FD${_.job.datadestruction}^FS`;
            }

            dataToWrite += "PQ1,0,1,Y^XZ";

            console.log(dataToWrite);
            _.selected_device.send(dataToWrite, undefined, function (errorMessage) {
                alert("Error: " + errorMessage);
            });
        },
        printSetup() {
            const _ = this,
                w = window;
            //Get the default device from the application as a first step. Discovery takes longer to complete.
            w.BrowserPrint.getDefaultDevice("printer", function (device) {

                //Add device to list of devices and to html select element
                _.selected_device = device;
                _.devices.push(device);
                console.log('device', _.selected_device);

                //Discover any other devices available to the application
                w.BrowserPrint.getLocalDevices(function (device_list) {
                    for (var i = 0; i < device_list.length; i++) {
                        //Add device to list of devices and to html select element
                        console.log(device_list);
                        var device = device_list[i];
                        if (!_.selected_device || device.uid != _.selected_device.uid) {
                            _.devices.push(device);
                        }
                    }

                }, function () {
                    alert("Error getting local devices")
                }, "printer");

            }, function (error) {
                //Browser Print Software not installed
                console.log("print error:" + error);
            })
        },
        getConfig() {
            const w = window;
            w.BrowserPrint.getApplicationConfiguration(function (config) {
                alert(JSON.stringify(config))
            }, function (error) {
                console.log(error);
                alert(JSON.stringify(new w.BrowserPrint.ApplicationConfiguration()));
            })
        }
    },
    watch: {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>
